import React, { useContext } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { CareRecipientConfigContext } from "../../../../provider/CareRecipientConfigProvider";
import { AssessmentInfoPage } from "./assessment_info/AssessmentInfoPage";
import { AlertSettingsPage } from "../../../alert_settings/AlertSettingsPage";
import { ContactsPage } from "../../../contacts/ContactsPage";

export const ConfigTabs = React.memo(function ConfigTabs() {
    const {
        tabIndex,
        setTabIndex
    } = useContext(CareRecipientConfigContext);

    return (
        <Tabs selectedIndex={tabIndex} onSelect={tabIndex => setTabIndex(tabIndex)}>
            {/* 切り替えタブ */}
            <div className={"tab-list_container"}>
                <TabList>
                    <Tab>利用者情報</Tab>
                    <Tab>アラート設定</Tab>
                    <Tab>連絡先設定</Tab>
                </TabList>
            </div>
            {/* 仕切り線 */}
            <hr className="border"/>
            {/* 各タブのコンテンツ */}
            <TabPanel>
                <AssessmentInfoPage />
            </TabPanel>
            <TabPanel>
                <AlertSettingsPage />
            </TabPanel>
            <TabPanel>
                <ContactsPage />
            </TabPanel>
        </Tabs>
    );
});
